import React from "react";
import CustomCheckBox from "../../../customCheckBox/customCheckBox";

interface CheckboxCellProps {
  value: {
    id: string;
    label: string;
    isChecked: boolean;
    isDisabled?: boolean;
  };
  toggleCheckboxSelection?: (id: string) => void;
  [key: string]: any;
}

/**
 * Renders a checkbox cell for custom-table rows.
 *
 * @param props - Checkbox value payload and optional toggle handler
 * @returns Checkbox cell markup
 */
export const CheckboxCell: React.FC<CheckboxCellProps> = ({
  value,
  toggleCheckboxSelection,
}) => {
  const isDisabled = value.isDisabled ?? false;

  return (
    <>
      <div
        className={`table-cell-checkbox flex items-center justify-start ${
          isDisabled ? "cursor-not-allowed opacity-60" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
          if (isDisabled) {
            return;
          }
          toggleCheckboxSelection?.(value.id);
        }}
      >
        <CustomCheckBox
          id={value.id}
          label={value.label}
          isChecked={value.isChecked}
          isDisabled={isDisabled}
          onCheckBoxValueChange={function (data: {
            name: string;
            value: boolean;
          }): void {}}
          removeGap={true}
        />
      </div>
    </>
  );
};

export default CheckboxCell;
